
/** Gestion du formulaire de Demande d'indemnisation **/
$(document).ready(function(){
    if ( window.location.hash == "#questionModal")
        $('#questionModal').modal({show: true})

    var tableInterventions = $("#table-interventions");
    var QRform = $('form#QRForm');

    initValues();
    calculMontantDemande(tableInterventions);

    /***** EVENT LISTENERS *****/

    initDIFormValidate();
    initMOAndFraisKmListener(tableInterventions);
    initInputsMontantDemandeListener(tableInterventions);
    initInputsMontantAccordeListener(tableInterventions);
    initInputsButtonsIndemniseListener(tableInterventions);
    initSuppressionIntervListener(tableInterventions);
    initSuppressionDIListener(rootUrl);
    initBtnRetourOperationListener(rootUrl);
    initOrganeAutocomplete(rootUrl);
    initBtnsQuestionReponseListener(QRform);
    initSuppressionQuestionReponseListener(rootUrl);
    initSuppressionNoteListener(rootUrl);
    initSuppressionDocumentListener(rootUrl);
    initSearchContractByTypeInterv(rootUrl, tableInterventions);

    $('#code_heure_intervention').change(function(){
       calculMontantDemande(tableInterventions);
    });

    $('#btn-ajout-intervention').click(function(){

       var vetuste = parseFloat($('#vetusteDateOperation').val());
       var isTransporteur = $('#isTransporteur').val();
       if(isNaN(vetuste)){
           vetuste = 0;
       }
       var remisePR = parseFloat($('#remisePR').val());
       if(isNaN(remisePR)){
           remisePR = 0;
       }

       var nouvelleIntervention =
        '<tr>'+
            '<td class="td-interv"><input type="text" class="form-control" name="organe[]"></td>'+
            '<td class="td-interv"><input type="number" class="form-control pull-left"  name="montantDemande[]" value="0"></td>'+
            '<td class="td-interv"><input type="number" step="0.01" class="form-control pull-left" name="montantAccorde[]" value="0"></td>'+
            '<td class="td-interv"><input type="number" step="0.01" class="form-control pull-left" name="vetuste[]" value="'+vetuste.toFixed(2)+'" readonly="readonly"></td>'+
            '<td class="td-interv"><input type="number" step="0.01" class="form-control pull-left" value="'+remisePR.toFixed(2)+'" readonly="readonly"></td>'+
            '<td class="td-interv"><input type="number" step="0.01" class="form-control pull-left" name="montantAIndemniser[]" value="0" readonly="readonly"></td>'+
            '<td>'+
                '<button type="button" class="btn btn-danger" name="btnIndemnise[]"><span class="glyphicon glyphicon-euro" aria-hidden="true"></span></button>'+
            '</td>'+
            '<td id="deleteInterv" class="delete" title="Supprimer l\'intervention">&times;</td>'+
        '</tr>';

        if(isTransporteur) {
            nouvelleIntervention =
            '<tr>'+
            '<td class=""><input type="text" class="form-control" name="organe[]"></td>'+
            '<td class=""><input type="number" step="0.01" class="form-control pull-left" name="montantAccorde[]" value="0">' +
            '<input type="hidden" name="vetuste[]" value="'+vetuste.toFixed(2)+'"></td>'+
            // '<td class="td-interv"><input type="number" step="0.01" class="form-control pull-left" value="'+remisePR.toFixed(2)+'" readonly="readonly"></td>'+
            '<td class=""><input type="number" step="0.01" class="form-control pull-left" name="montantAIndemniser[]" value="0" readonly="readonly"></td>'+
            '<td>'+
            '<button type="button" class="btn btn-danger" name="btnIndemnise[]"><span class="glyphicon glyphicon-euro" aria-hidden="true"></span></button>'+
            '</td>'+
            '<td id="deleteInterv" class="delete" title="Supprimer l\'intervention">&times;</td>'+
            '</tr>';
        }

        tableInterventions.append(nouvelleIntervention);
        initOrganeAutocomplete(rootUrl);
    });

    $('#decision').change(function(){
        if($('#decision').val()=="accord"){
            $('#detailAcceptForm').css('display','block');
            $('#detailRefusForm').css('display','none');
            $('#raisonsRefus').css('display','none');
        }
        else if($('#decision').val()=="accord-sans-rep"){
            $('#detailRefusForm').css('display','none');
            $('#raisonsRefus').css('display','none');
            $('#detailAcceptForm').css('display','none');
        }
        else if($('#decision').val()=="refus"){
            $('#detailRefusForm').css('display','block');
            $('#raisonsRefus').css('display','block');
            $('#detailAcceptForm').css('display','none');
        }
        else{
            $('#detailRefusForm').css('display','none');
            $('#raisonsRefus').css('display','block');
            $('#detailAcceptForm').css('display','none');
        }
    });

    $("input:checkbox.refus").change(function(){
        if($('.form-check-input:checked').length<2){
            if($(this).is(':checked')){
                if($(this).val()=='3'){
                    $('#1').attr("disabled", true);
                    $('#2').attr("disabled", true);
                    $('#8').attr("disabled", true);
                    $('#9').attr("disabled", true);
                    $('#10').attr("disabled", true);
                    $('#11').attr("disabled", true);
                    $('#12').attr("disabled", true);
                    $('#13').attr("disabled", true);
                    $('#14').attr("disabled", true);
                    $('#15').attr("disabled", true);
                    $('#16').attr("disabled", true);
                }
                else{
                    $('.form-check-input').each(function(){
                        if(!$(this).is(':checked')){
                            this.disabled=true;
                        }
                    });
                }
            }
            else{
                $('.form-check-input').attr("disabled",false);
            }
        }
        else{
            $('.form-check-input').each(function(){
               if(!$(this).is(':checked')){
                   this.disabled=true;
               }
            });
        }

    });
});

/***** FUNCTIONS *****/

function initValues(){
    var init = 0;
    var tempsDemande = $('#temps_total_demande');
    var tempsAccorde = $('#temps_total_accorde');
    var coutMO = $('#cout_horaire');
    var montantDemandeMO = $('#montant_demande_mo');
    var montantTotalDemande = $('#montant_total_demande');
    var montantTotalAccorde = $('#montant_total_accorde');
    var montantTotalAIndemniser = $('#montant_total_a_indemniser');
    var montantDemandePR = $('#montantDemandePR');
    var montantAccordePR = $('#montantAccordePR');
    var montantAIndemniserPR = $('#montantAIndemniserPR');
    var kmDepannes = $('#fraisNbKmAccordes');
    var kmTaux = $('#fraisKmTaux');
    var fraisKmTotal = $('#fraisKmTotal');

    if(tempsDemande.val() == ""){
        tempsDemande.val(init.toFixed(2));
    }
    if(tempsAccorde.val() == ""){
        tempsAccorde.val(init.toFixed(2));
    }
    if(coutMO.val() == ""){
        coutMO.val(init.toFixed(2));
    }
    if(montantDemandeMO.val() == ""){
        montantDemandeMO.val(init.toFixed(2));
    }
    if(montantTotalDemande.val() == ""){
        montantTotalDemande.val(init.toFixed(2));
    }
    if(montantTotalAccorde.val() == ""){
        montantTotalAccorde.val(init.toFixed(2));
    }
    if(montantTotalAIndemniser.val() == ""){
        montantTotalAIndemniser.val(init.toFixed(2));
    }
    if(montantDemandePR.val() == ""){
        montantDemandePR.val(init.toFixed(2));
    }
    if(montantAccordePR.val() == ""){
        montantAccordePR.val(init.toFixed(2));
    }
    if(montantAIndemniserPR.val() == ""){
        montantAIndemniserPR.val(init.toFixed(2));
    }
    if(kmDepannes.val() == ""){
        kmDepannes.val(init.toFixed(2));
    }
    if(kmTaux.val() == ""){
        kmTaux.val(init.toFixed(2));
    }
    if(fraisKmTotal.val() == ""){
        fraisKmTotal.val(init.toFixed(2));
    }

    $('[name^=vetuste]').each(function(){
        if($(this).val() == ""){
            $(this).val(init.toFixed(2));
        }
    });

    $('[name^=remisePR]').each(function(){
        if($(this).val() == ""){
            $(this).val(init.toFixed(2));
        }
    });
}

function initMOAndFraisKmListener(tableInterventions){
    $('#temps_total_demande, #temps_total_accorde, #cout_horaire, #fraisNbKmAccordes, #fraisKmTaux').on({
        change: function(){
            stringToFloatByEvent($(this), "change");
            calculMontantDemande(tableInterventions);
        },
        keyup: function(){
            stringToFloatByEvent($(this), "keyup");
            calculMontantDemande(tableInterventions);
        }
    });
}

function initInputsMontantDemandeListener(tableInterventions){
    tableInterventions.on("change", "[name^='montantDemande']", function(){
        stringToFloatByEvent($(this), "change");
        calculMontantDemande(tableInterventions);
    });
    tableInterventions.on("keyup", "[name^='montantDemande']", function(){
        stringToFloatByEvent($(this), "keyup");
        calculMontantDemande(tableInterventions);
    });
}

function initInputsMontantAccordeListener(tableInterventions){
    tableInterventions.on("change", "[name^='montantAccorde']", function(){
        stringToFloatByEvent($(this), "change");
        calculMontantDemande(tableInterventions);
    });
    tableInterventions.on("keyup", "[name^='montantAccorde']", function(){
        stringToFloatByEvent($(this), "keyup");
        calculMontantDemande(tableInterventions);
    });
}

function initBtnsQuestionReponseListener(form){
    $('#btnQRQuestion').click(function(){
        $('#rowQRBtns').addClass('hide');
        $('#rowQRtextarea').removeClass('hide');
        form.find('[name=QRType]').val('question');
        form.find('label').html('Votre question : ');
    });
    $('#btnQRReponse').click(function(){
        $('#rowQRBtns').addClass('hide');
        $('#rowQRtextarea').removeClass('hide');
        form.find('[name=QRType]').val('réponse');
        form.find('label').html('Votre réponse : ');
    });
    $('#btnQRAnnuler').click(function(){
        $('#rowQRtextarea').addClass('hide');
        $('#rowQRBtns').removeClass('hide');
        form.find('[name=QRType]').val('');
        form.find('label').html('');
    });
}

function initSuppressionQuestionReponseListener(rootUrl){
    $('.delete-question').click(function(){
        var verif = confirm("Voulez-vous vraiment supprimer cette question ?");
        if(verif){
            var questionId = $(this).parent().find("span.hide").text(); // On remonte au <p> et on cherche le text() du span avec la classe "hide" pour récupérer l'id de la question voulue.
            $.ajax({
                type: 'GET',
                url: rootUrl+'operations/supprimerQuestion',
                data: { questionId: questionId },
                async: true,
                dataType: 'text',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
                beforeSend:function(xhr){
                    xhr.overrideMimeType('text/html;charset=UTF-8');
                },
                success:function(data, textStatus){
                    location.reload();
                },
                error:function(xhr, textStatus, thrownError){
                    alert('Erreur AJAX : '+thrownError);
                }
            });
        }
    });
    $('.delete-reponse').click(function(){
        var verif = confirm("Voulez-vous vraiment supprimer cette réponse ?");
        if(verif){
            var reponseId = $(this).parent().find("span.hide").text(); // On remonte au <p> et on cherche le text() du span avec la classe "hide" pour récupérer l'id de la réponse voulue.
            $.ajax({
                type: 'GET',
                url: rootUrl+'operations/supprimerReponse',
                data: { reponseId: reponseId },
                async: true,
                dataType: 'text',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
                beforeSend:function(xhr){
                    xhr.overrideMimeType('text/html;charset=UTF-8');
                },
                success:function(data, textStatus){
                    location.reload();
                },
                error:function(xhr, textStatus, thrownError){
                    alert('Erreur AJAX : '+thrownError);
                }
            });
        }
    });
}

function initSuppressionNoteListener(rootUrl){
    $('.delete-note').click(function(){
        var verif = confirm("Voulez-vous vraiment supprimer cette note ?");
        if(verif){
            var noteId = $(this).parent().find("span.hide").text(); // On remonte au <tr> et on cherche le text() du span avec la classe "hide" pour récupérer l'id de la note voulue.
            $.ajax({
                type:'GET',
                url: rootUrl+'operations/supprimerNote',
                data: { noteId: noteId },
                async: true,
                dataType: 'text',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
                beforeSend:function(xhr){
                    xhr.overrideMimeType('text/html;charset=UTF-8');
                },
                success:function(data, textStatus){
                    location.reload();
                },
                error:function(xhr, textStatus, thrownError){
                    alert('Erreur AJAX : '+thrownError);
                }
            });
        }
    });
}

function initSuppressionDocumentListener(rootUrl){
    $('.delete-doc').click(function(){
        var verif = confirm("Voulez-vous vraiment supprimer ce document ?");
        if(verif){
            var demandeId = $('#diId').val();
            var docName = $(this).parent().children().first().children().text(); // On remonte au <tr>, on prend le text() du <a> à l'intérieur du premier <td>
            $.ajax({
                type:'GET',
                url: rootUrl+'operations/supprimerDocument',
                data: { demandeId: demandeId, docName: docName },
                async: true,
                dataType: 'text',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
                beforeSend:function(xhr){
                    xhr.overrideMimeType('text/html;charset=UTF-8');
                },
                success:function(data, textStatus){
                    location.reload();
                },
                error:function(xhr, textStatus, thrownError){
                    alert('Erreur AJAX : '+thrownError);
                }
            });
        }
    });
}

function initInputsButtonsIndemniseListener(tableInterventions){
    tableInterventions.on("click", "[name^=btnIndemnise]", function(){
        if($(this).hasClass("btn-success")) {
            $(this).removeClass("btn-success");
            $(this).addClass("btn-danger");
            calculMontantDemande(tableInterventions);
        }
        else {
            $(this).removeClass("btn-danger");
            $(this).addClass("btn-success");
            calculMontantDemande(tableInterventions);
        }
    });
}

function initBtnRetourOperationListener(rootUrl){
    $("#btn-retour-operation").click(function(){
        var operationId = $('[name=operationId]').val();
        document.location.href = rootUrl+"operations/"+operationId;
    })
}

function initSuppressionIntervListener(tableInterventions){
    tableInterventions.on("click", "#deleteInterv", function(){
        var verif = confirm("Voulez-vous vraiment supprimer cette intervention ?");
        if(verif){
            $(this).parent().remove();
            calculMontantDemande(tableInterventions);
        }
    });
}

function initSuppressionDIListener(rootUrl){
    $('#btn-supprimer-demande').click(function(){
        var verif = confirm("Voulez-vous vraiment supprimer cette demande d'indemnisation ?");
        if(verif){
            var demandeId = $('[name=diId]').val();
            $.ajax({
                type:'GET',
                url: rootUrl+'operations/supprimerDemande',
                data: { demandeId: demandeId },
                async: true,
                dataType: 'text',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
                beforeSend:function(xhr){
                    xhr.overrideMimeType('text/html;charset=UTF-8');
                },
                success:function(data, textStatus){
                    var operationId = $('[name=operationId]').val();
                    document.location.href=rootUrl+'operations/'+operationId;
                },
                error:function(xhr, textStatus, thrownError){
                    alert('Erreur AJAX : '+thrownError);
                }
            });
        }
    });
}

function initDIFormValidate(){

    $.extend($.validator.messages, {
        required: "Veuillez renseigner ce champ"
    });

    $('form#di-form').validate({
        onkeyup: false,
        onfocusout: false,
        errorElement: "div",
        errorPlacement: function (error, element) {
            error.insertAfter("div.di-type-interv div.col-xs-3").wrap("<div class='col-xs-12 col-md-5'></div>");
        },
        rules: {
            "typeIntervention": {
                required: true
            }
        }
    });
}

function initSearchContractByTypeInterv(rootUrl, tableInterventions){
    $('#typeIntervention').change(function(){
        var typeInterventionId = $(this).val();
        var operationId = $('[name=operationId]').val();
        $.ajax({
            type:'GET',
            url: rootUrl+'operations/searchContractByTypeInterv',
            data: { typeInterventionId: typeInterventionId, operationId : operationId },
            async: true,
            dataType: 'text',
            contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
            beforeSend:function(xhr){
                xhr.overrideMimeType('text/html;charset=UTF-8');
            },
            success:function(data, textStatus){
                data = JSON.parse(data);

                var vetuste = 0, plancher = 0, plafond = 0.000001; // Plafond à ce niveau => impossible d'indemniser la demande. TODO voir pour impossibilité d'ajout intervention si pas de contrat
                if(data.vetuste != 0 && data.vetuste !== null){
                    vetuste = data.vetuste.taux;
                }
                if(data.plancher !== null){
                    plancher = data.plancher;
                }
                if(data.plafond !== null){
                    plafond = data.plafond;
                }
                var remiseMO = data.remiseMO;
                var remisePR = data.remisePR;

                var typeInterventionLibelle = $('#typeIntervention').find(':selected').text();
                if(typeInterventionLibelle == "Dépannage"){
                    $("#divFraisKm").removeClass("hide");
                }
                else {
                    $("#divFraisKm").addClass("hide");
                }

                $('#vetusteDateOperation').val(parseFloat(vetuste).toFixed(2));
                $('[name^=vetuste]').each(function(){
                    $(this).val(parseFloat(vetuste).toFixed(2));
                });
                $('#remiseMO').val(parseFloat(remiseMO).toFixed(2));
                $('#remisePR').val(parseFloat(remisePR).toFixed(2));
                $('[name^=remisePR]').each(function(){
                    $(this).val(parseFloat(remisePR).toFixed(2));
                });
                $('#plancherContrat').val(parseFloat(plancher).toFixed(2));
                $('#plafondContrat').val(parseFloat(plafond).toFixed(2));
                $('#warningPlancherValue').html(parseFloat(plancher).toFixed(2));
                $('#warningPlafondValue').html(parseFloat(plafond).toFixed(2));

                calculMontantDemande(tableInterventions);
            },
            error:function(xhr, textStatus, thrownError){
                alert('Erreur AJAX : '+thrownError);
            }
        });
    });
}

function initOrganeAutocomplete(rootUrl){
    $("[name^=organe]").autocomplete({
        source: rootUrl+'operations/organes',
        minLength: 2
    })
}

function stringToFloatByEvent(objet, event){
    var nb = 0;
    if(event == "keyup"){
        nb = parseFloat(objet.val());
        return; // Saisie encore en cours, ne touche pas à objet.val(), retourne null.
    }
    else if(event == "change"){
        nb = parseFloat(objet.val());
        if(isNaN(nb)){
            nb = 0;
        }
    }
    objet.val(nb.toFixed(2));
}

function calculMontantMO(){
    var isTransporteur = $('#isTransporteur').val();
    var contratCoutHoraire = parseFloat($('#contrat_cout_horaire').val());
    if (!isNaN(contratCoutHoraire)) {
        $('#cout_horaire').attr({
            "max": $('#contrat_cout_horaire').val()
        });
    }
    var coutHoraire = parseFloat($('#cout_horaire').val());
    var montantDemandeMO = parseFloat($('#temps_total_demande').val()) * coutHoraire;
    var montantAccordeMO = parseFloat($('#temps_total_accorde').val()) * coutHoraire;
    var codeHeure = $('#code_heure_intervention').val();
    if(codeHeure == 2){ // Nuit
        montantAccordeMO = montantAccordeMO * 2;
        montantDemandeMO = montantDemandeMO * 2;
    }
    else if(codeHeure == 3){ // TS +50%
        montantAccordeMO = montantAccordeMO * 1.5;
        montantDemandeMO = montantDemandeMO * 1.5;
    }

    $('#montant_demande_mo').val(montantDemandeMO.toFixed(2));
    $('#montant_accorde_mo').val(montantAccordeMO.toFixed(2));

    var remiseMO = parseFloat($('#remiseMO').val());
    var indemniseMO = montantAccordeMO *(1-(remiseMO/100)); // Vérifier calcul après remise à terme ; juste un exemple
    if(isTransporteur) {
        indemniseMO = montantDemandeMO;
    }
    $('#indemnise_mo').val(indemniseMO.toFixed(2));

    return montantAccordeMO;
}

function calculFraisKilometriques(){
    var nbKmDepannes = parseFloat($('#fraisNbKmAccordes').val());
    var kmTaux = parseFloat($('#fraisKmTaux').val());
    var fraisKmTotal = nbKmDepannes * kmTaux;

    $('#fraisKmTotal').val(fraisKmTotal.toFixed(2));

    return fraisKmTotal;
}

function calculMontantDemande(tableInterventions){
    var sommeMontantDemande = 0, sommeMontantAccorde = 0, sommeMontantAIndemniser = 0, i = 0;

    var plafond = parseFloat($('#plafondContrat').val());
    var plancher = parseFloat($('#plancherContrat').val());

    if(!$('#divFraisKm').hasClass("hide")){
        var fraisKilometriques = calculFraisKilometriques();
        sommeMontantDemande += fraisKilometriques;
        sommeMontantAccorde += fraisKilometriques;
        sommeMontantAIndemniser += fraisKilometriques;
    }

    var someInterventions = false;

    sommeMontantAccorde += calculMontantMO();
    sommeMontantAIndemniser += parseFloat($('#indemnise_mo').val());
    var montantDemandeMO = parseFloat($('#montant_demande_mo').val());

    if($("#remisePR").next().length > 0){
        someInterventions = true;
    }
    if(someInterventions == true){
        var inputsMontantDemande = tableInterventions.find("[name^='montantDemande']");
        var inputsMontantAccorde = tableInterventions.find("[name^='montantAccorde']");
        var inputsVetuste = tableInterventions.find("[name^=vetuste]");
        var inputsMontantAIndemniser = tableInterventions.find("[name^=montantAIndemniser]");
        var inputButtons =  tableInterventions.find("[name^=btnIndemnise]");
        var montantDemandePR = 0, montantAccordePR = 0, montantAIndemniserPR = 0;

        inputsMontantDemande.each(function(){
            montantDemandePR += parseFloat($(this).val());
        });

        i = 0;
        inputsMontantAccorde.each(function(){
            var montantAccorde = parseFloat($(this).val());
            var remisePR = parseFloat($('#remisePR').val());
            var currentVetuste = parseFloat(inputsVetuste.eq(i).val());
            var montantAIndemniser = parseFloat(montantAccorde*(1-(remisePR/100))*(1-(currentVetuste/100)));

            var reInit = 0;
            if(inputButtons.eq(i).hasClass("btn-success")){
                inputsMontantAIndemniser.eq(i).val(montantAIndemniser.toFixed(2));
                montantAIndemniserPR += montantAIndemniser;
            }
            else {
                inputsMontantAIndemniser.eq(i).val(reInit.toFixed(2));
            }
            montantAccordePR += montantAccorde;

            i++;
        });

        $('#montantDemandePR').val(montantDemandePR.toFixed(2));
        $('#montantAccordePR').val(montantAccordePR.toFixed(2));
        $('#montantAIndemniserPR').val(montantAIndemniserPR.toFixed(2));

        sommeMontantDemande += montantDemandePR;
        sommeMontantAccorde += montantAccordePR;
        sommeMontantAIndemniser += montantAIndemniserPR;
    }
    $('#montant_total_demande').val((sommeMontantDemande + montantDemandeMO).toFixed(2));

    if(plafond > 0 && sommeMontantAccorde > plafond){ // Si le montant total accordé dépasse le plafond, on le set au niveau du plafond et on affiche le texte pour alerter l'utilisateur
        if($("#montant_total_accorde").val()){
            $("#warningPlancher").addClass('hide');
            $("#warningPlafond").removeClass('hide');
        }
        sommeMontantAccorde = plafond;
    } else if (plancher > 0 && sommeMontantAccorde < plancher){ // Si le montant total accordé est inférieur au plancher, on le set à 0 (comme le montant à indemniser) et on affiche l'alerte adéquate
        if($("#montant_total_accorde").val()){
            $("#warningPlafond").addClass('hide');
            $("#warningPlancher").removeClass('hide');
        }
        sommeMontantAccorde = 0;
        sommeMontantAIndemniser = 0;
    }
    else{
        $("#warningPlancher").addClass('hide');
        $("#warningPlafond").addClass('hide');
    }
    if(plafond > 0 && sommeMontantAIndemniser > plafond){
        sommeMontantAIndemniser = plafond;
    }

    $('#montant_total_accorde').val(sommeMontantAccorde.toFixed(2));

    $('#montant_total_a_indemniser').val(sommeMontantAIndemniser.toFixed(2));
}